import { useMemo, useRef } from "react";

/**
 * @example
 * ```ts
 * const obj = { a: 1, b: 2 };
 * const obj2 = useObjectDeps(obj);
 *
 * useEffect(() => {
 *   console.log(obj2);
 * }, [obj2]);
 * ```
 */
export function useObjectDep<T extends Record<string, any>>(values: T): T {
  const prevValues = useRef<T>(values);
  const changed =
    Object.keys(values).length !== Object.keys(prevValues.current).length ||
    Object.keys(values).some((key) => values[key] !== prevValues.current[key]);

  const keyRef = useRef(1);
  if (changed) {
    prevValues.current = values;
    keyRef.current++;
  }

  return useMemo(() => prevValues.current, [keyRef.current]);
}
